import { OEM_HISTORY_REQUEST, OEM_HISTORY_SUCCESS, OEM_HISTORY_FAIL } from '../type/type';
import axios from "axios";
const PROXY = process.env.REACT_APP_API_URL + 'api/';

export const fetchOEMHistory = (id, type) => async (dispatch) => {
    try {
        dispatch({ type: OEM_HISTORY_REQUEST });

        const res = await axios.get(PROXY + `leads/oemHistory/${id}?type=${type}`);

        dispatch({
            type: OEM_HISTORY_SUCCESS,
            payload: res.data.result,
        });

        return res
    } catch (error) {
        dispatch({
            type: OEM_HISTORY_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};